import {jwtDecode} from 'jwt-decode';

const JwtDecodeService = (accessToken) => {
  if (!accessToken) return null;

  try {
    const decodedToken = jwtDecode(accessToken);

    // Transform payload
    const transformedPayload = {
      sub: decodedToken?.sub,
      aud: decodedToken?.aud,
      "user-authorities": decodedToken?.["user-authorities"] || ["CUSTOMER"], // Default to "CUSTOMER" if missing
      nbf: decodedToken?.nbf,
      scope: decodedToken?.scope,
      iss: decodedToken?.iss,
      exp: decodedToken?.exp,
      iat: decodedToken?.iat
    };

    return transformedPayload;
  } catch (error) {
    console.error("Error decoding JWT token:", error);
    return null;
  }
};

export default JwtDecodeService;
